// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import {injectIntl, intlShape} from 'react-intl';
import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import {Radio} from 'cap-it-ui.toggles';

const RadioButtonRow = props => {

    const translatedLabel = props.intl.formatMessage({id: props.item.value});

    return (
        <li className={props.className}>
            <Radio
                id={props.item.key}
                onChange={props.onItemUpdate}
                selected={props.isSelected}
            >
                {translatedLabel}
            </Radio>
        </li>
    );

};

RadioButtonRow.displayName = 'RadioButtonRow';

RadioButtonRow.propTypes = {
    className: PropTypes.string,
    intl: intlShape.isRequired,
    isSelected: PropTypes.bool.isRequired,
    item: PropTypes.instanceOf(KeyValuePair),
    onItemUpdate: PropTypes.func.isRequired
};
RadioButtonRow.defaultProps = {
    className: ''
};

export default injectIntl(RadioButtonRow);



// WEBPACK FOOTER //
// ./src/shared/components/radio-button-list/radio-button-row.js